module.exports = __webpack_public_path__ + "assets/img/block-right-hover-9be3f320.png";